import type { IconData } from '@stacksjs/iconify-core'

export const graph: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M432 32a63.973 63.973 0 0 0-34.344 117.963L355.894 296.13A64 64 0 0 0 352 296a63.66 63.66 0 0 0-38.193 12.678l-77.154-64.295A64 64 0 1 0 131.259 269.7l-45.292 90.588A64 64 0 0 0 80 360a64.082 64.082 0 1 0 36.243 11.29l42.8-85.589a63.85 63.85 0 0 0 59.982-14.356l74.7 62.252a64 64 0 1 0 92.621-27.56l41.76-146.167c1.289.078 2.585.13 3.894.13a64 64 0 0 0 0-128M80 456a32 32 0 1 1 32-32a32.036 32.036 0 0 1-32 32m96-200a32 32 0 1 1 32-32a32.036 32.036 0 0 1-32 32m176 136a32 32 0 1 1 32-32a32.036 32.036 0 0 1-32 32m80-264a32 32 0 1 1 32-32a32.036 32.036 0 0 1-32 32\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default graph
